/* Photo views of the regular tee: recolour the garment in a photograph and lay the
   print on it. Port of final-mockups/t-shirts/gallery/renderer.js (summer-v2e),
   split into a colour-independent ink pass and a per-colour paint pass so a swatch
   change never re-warps the artwork. Colour targets come from ClassicMaterial. */
(function(root,factory){if(typeof module==='object'&&module.exports)module.exports=factory();else root.TeePhotoRenderer=factory()})(typeof globalThis!=='undefined'?globalThis:this,function(){
  'use strict'
  const size=1080
  const luma=(r,g,b)=>r*.2126+g*.7152+b*.0722
  // Lighter shirts pair with charcoal bottoms; deeper colours with warm stone.
  function bottomColour(target){return target.mid<110?[188,173,151]:[52,52,54]}
  // Print-rect coordinates (0..1) of a photo pixel, with the fabric curve around the body.
  function cloth(view,x,y){
    const p=view.print,u0=(x-p.x)/p.width,v0=(y-p.y)/p.height
    if(!view.curve)return {x:u0,y:v0}
    const t=view.curve
    return {x:(Math.asin(Math.max(-1,Math.min(1,(u0*2-1)*Math.sin(t))))/t+1)/2,y:v0-view.sag*(1-4*(u0-.5)*(u0-.5))}
  }
  // Masks and the crease map are greyscale PNGs: keep one byte per pixel (the red
  // channel) so nine views stay under ~10 MB each in memory.
  function channel(image){const out=new Uint8Array(size*size);for(let p=0;p<out.length;p++)out[p]=image.data[p*4];return out}
  function prepare(view,source,mask,displacement,bottoms){
    const lum=new Uint8ClampedArray(size*size)
    for(let p=0;p<lum.length;p++){const i=p*4;lum[p]=luma(source.data[i],source.data[i+1],source.data[i+2])}
    return {view,source:source.data,mask:channel(mask),disp:channel(displacement),bottoms:bottoms?channel(bottoms):null,luma:lum}
  }
  /**
   * The print, warped onto the fabric. `place` is the artwork's box inside the
   * print rectangle in 0..1 units: {ox, oy, aw, ah}. Returns RGBA, size x size,
   * with the ink already toned for the photo (the white-shirt target).
   */
  function ink(material,art,place,white){
    const N=size,v=material.view,p=v.print,D=material.disp,mask=material.mask,out=new Uint8ClampedArray(N*N*4)
    if(!p||!art)return out
    const x0=Math.max(6,Math.floor(p.x)-12),x1=Math.min(N-7,Math.ceil(p.x+p.width)+12),y0=Math.max(6,Math.floor(p.y)-12),y1=Math.min(N-7,Math.ceil(p.y+p.height)+12)
    for(let y=y0;y<y1;y++)for(let x=x0;x<x1;x++){
      const pi=y*N+x,i=pi*4;if(!mask[pi])continue
      const dx=Math.max(-6,Math.min(6,(D[pi+5]-D[pi-5])*.4)),dy=Math.max(-4,Math.min(4,(D[pi+5*N]-D[pi-5*N])*.2))
      const q=cloth(v,x+dx,y+dy),edge=cloth(v,x,y)
      const sx=(q.x-place.ox)/place.aw*(art.width-1),sy=(q.y-place.oy)/place.ah*(art.height-1)
      if(!(edge.x>=0&&edge.x<=1&&edge.y>=0&&edge.y<=1&&q.x>=0&&q.x<=1&&q.y>=0&&q.y<=1&&sx>=0&&sy>=0&&sx<art.width-1&&sy<art.height-1))continue
      const ix=Math.floor(sx),iy=Math.floor(sy),fx=sx-ix,fy=sy-iy;let alpha=0;const c=[0,0,0]
      for(let j=0;j<2;j++)for(let k=0;k<2;k++){const a=((iy+j)*art.width+ix+k)*4,w=(k?fx:1-fx)*(j?fy:1-fy)*art.data[a+3]/255;alpha+=w;for(let ch=0;ch<3;ch++)c[ch]+=art.data[a+ch]*w}
      if(!alpha)continue
      for(let ch=0;ch<3;ch++)out[i+ch]=20+(white[ch]-20)*c[ch]/alpha/255
      out[i+3]=Math.min(255,alpha*255)
    }
    return out
  }
  /** Recolour the garment (and the bottoms) and lay the ink on it. `target` is a ClassicMaterial colour target {rgb, low, mid, high}. */
  function paint(material,target,inkLayer){
    const N=size,v=material.view,a=material.source,mask=material.mask,out=new Uint8ClampedArray(a),rgb=target.rgb,r=v.reference,centre=luma(rgb[0],rgb[1],rgb[2]),bottomTarget=bottomColour(target)
    for(let p=0;p<N*N;p++){
      const i=p*4,m=mask[p]/255
      if(material.bottoms){const bm=material.bottoms[p]/255;if(bm){const shade=Math.min(1.3,Math.pow(material.luma[p]/v.bottoms.mid,.85));for(let k=0;k<3;k++)out[i+k]=a[i+k]*(1-bm)+Math.min(255,bottomTarget[k]*shade)*bm}}
      if(!m)continue
      const lum=material.luma[p],below=Math.max(0,(r.mid-lum)/Math.max(1,r.mid-r.low)),above=Math.max(0,(lum-r.mid)/Math.max(1,r.high-r.mid))
      const s=Math.min(.98,below*(target.mid-target.low)/Math.max(1,target.mid)),h=Math.min(.95,above*(target.high-target.mid)/Math.max(1,255-centre))
      const alpha=inkLayer?inkLayer[i+3]/255:0
      for(let k=0;k<3;k++){const ink=inkLayer?inkLayer[i+k]:0;out[i+k]=a[i+k]*(1-m)+(rgb[k]*(1-alpha)+ink*alpha)*(1-s)*(1-h)*m+255*h*m}
    }
    return out
  }
  return {size,cloth,prepare,ink,paint,bottomColour}
})
